<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        bottom: 59px;
    }

    rect {
        position: absolute;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 532 72">
    <g id="Layer_2" data-name="Layer 2">
        <g id="cardtext">
            <rect class="label1" {fill} x="6" width="245" height="29.06" />
            <rect class="label2" {fill} x="258" width="245" height="29.06" />
            <rect class="label3" {fill} x="510" width="22" height="29.06" />
        </g>
    </g>
</svg>
